<template>
    <div class="ado-admin">
        <ado-admin-sidebar></ado-admin-sidebar>
        <div id="dashboard">
            <div id="nav">
                <button type="button" id="sidebarCollapse" class="btn btn-sm btn-primary">
                    <i class="far fa-bars"></i>
                    <span> Menu</span>
                </button>
                <div v-if="user.name" class="ado-admin__user"><span class="ado-admin__user-welcome">Hi, </span> <span
                        class="ado-admin__user-name">{{ user.name }}</span></div>
            </div>
            <router-view />
        </div>
    </div>
</template>

<script>
import Auth from '../../js/auth';
import $ from 'jquery';
import 'jquery-mousewheel/jquery.mousewheel.js';
import 'malihu-custom-scrollbar-plugin/jquery.mCustomScrollbar.js';
import 'malihu-custom-scrollbar-plugin/jquery.mCustomScrollbar.css';
import AdoAdminDashboard from './Dashboard';
import AdoAdminSidebar from './Sidebar';

export default {
    name: 'ado-admin',
    components: {
        AdoAdminDashboard,
        AdoAdminSidebar
    },
    data() {
        return {
            user: {}
        }
    },
    created() {
        // Retrieve user
        this.user = Auth.getUser();
    },
    mounted() {
        // Sidebar initialization
        $("#sidebar").mCustomScrollbar({
            theme: "minimal"
        });

        $('#sidebarCollapse').on('click', function () {
            $('#sidebar, #dashboard').toggleClass('active');
            $('.collapse.in').toggleClass('in');
            $('a[aria-expanded=true]').attr('aria-expanded', 'false');
        });
    }
}
</script>

<style>
#dashboard {
    background: #f2f3f8;
    width: calc(100% - 250px);
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
    padding: 0;
    min-height: 100vh;
    position: absolute;
    top: 0;
    right: 0;
}

#dashboard.active {
    width: 100%;
}

#nav {
    background-color: #ffffff;
    border-bottom: 1px solid #eff0f6;
    padding: 1rem;
}

.ado-admin__user {
    color: #6c7293;
    font-size: 1rem;
    float: right;
    padding-right: 1rem;
}

.ado-admin__user-name {
    -webkit-transition: all 0.3s;
    transition: all 0.3s;
    color: #6c7293;
    font-weight: 600;
}

.ado-admin__user-welcome {
    -webkit-transition: all 0.3s;
    transition: all 0.3s;
    color: #959cb6;
}

.btn-icon {
    width: 42px;
}

.btn-primary {
    background-color: #5867dd;
    border-color: #5867dd;
    color: #ffffff;
}

.btn-primary:hover {
    color: #fff;
    background-color: #384ad7;
    border-color: #2e40d4;
}

.btn-success {
    background-color: #0abb87;
    border-color: #0abb87;
    color: #ffffff;
}

.btn-success:hover {
    color: #fff;
    background-color: #08976d;
    border-color: #078b64;
}

.btn-warning {
    background-color: #ffb822;
    border-color: #ffb822;
    color: #111111;
}

.btn-warning:hover {
    color: #212529;
    background-color: #fbaa00;
    border-color: #eea200;
}

.btn-light-primary {
    background-color: rgba(93, 120, 255, 0.1);
    color: #5d78ff;
    -webkit-transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
    transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
    transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
}

.btn-light-primary:hover {
    background-color: #5d78ff;
    color: #ffffff;
}

.btn-light-success {
    background-color: rgba(10, 187, 135, 0.1);
    color: #0abb87;
    -webkit-transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
    transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
    transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
}

.btn-light-success:hover {
    background-color: #0abb87;
    color: #ffffff;
}

.btn-light-danger {
    background-color: rgba(220, 53, 69, 0.1);
    color: #dc3545;
    -webkit-transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
    transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
    transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
}

.btn-light-danger:hover {
    background-color: #dc3545;
    color: #ffffff;
}

.btn-light-warning {
    background-color: rgba(255, 184, 34, 0.1);
    color: #ffb822;
    -webkit-transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
    transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
    transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
}

.btn-light-warning:hover {
    background-color: #ffb822;
    color: #111111;
}

.btn-tooltip {
    display: inline-block;
}

.modal-backdrop {
    background-color: rgba(0, 0, 0, .275);
}

.modal-content {
    font-family: 'Poppins', sans-serif;
}

@media (max-width: 768px) {
    #dashboard {
        width: 100%;
    }

    #dashboard.active {
        width: calc(100% - 250px);
    }
}
</style>